
const enum ContactType {
    'Commune',
    'Merchant',
    'Person',
    'Employee'

};

const enum ContactStatus {
    'New',
    'Changed',
    'Deleted'

};
import { User } from '../../shared';
import { Salesunit } from '../salesunit';
export class Contact {
    constructor(
        public id?: number,
        public type?: ContactType,
        public salutation?: string,
        public title?: string,
        public firstname?: string,
        public lastname?: string,
        public displayname?: string,
        public company?: string,
        public companyAdditional?: string,
        public street?: string,
        public streetAdditional?: string,
        public zipcode?: string,
        public city?: string,
        public suburb?: string,
        public state?: string,
        public country?: string,
        public phone?: string,
        public phoneAdditional?: string,
        public fax?: string,
        public mobile?: string,
        public email?: string,
        public emailAdditional?: string,
        public web?: string,
        public comment?: string,
        public companyGguid?: string,
        public casIsCompany?: boolean,
        public casIsContact?: boolean,
        public latitude?: string,
        public longitude?: string,
        public boothUnit?: string,
        public boothType?: string,
        public radius?: string,
        public boothWidth?: number,
        public boothDepth?: number,
        public assortment?: string,
        public assortmentAdditional?: string,
        public activeMerchant?: boolean,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public status?: ContactStatus,
        public user?: User,
        public salesunits?: Salesunit,
        public superordinateContact?: Contact,
        public subordinateContacts?: Contact,
    ) {
        this.casIsCompany = false;
        this.casIsContact = false;
        this.activeMerchant = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/contact.model.ts